module.exports = __webpack_public_path__ + "img/horizontal_4_3_1.fc645793.png";